<template>
  <!-- Preloader -->
  <div
    v-if="loading"
    id="pre-loader"
    class="fixed inset-0 z-50 flex items-center justify-center bg-white"
  >
    <img v-if="loaderGIF" :src="loaderGIF" class="w-24 h-24" alt="Loading..." />
  </div>

  <!-- Overlay -->
  <div class="overlay fixed inset-0 z-10 pointer-events-none" />

  <!-- Main content slot -->
  <main class="relative z-10">
    <slot />
  </main>

  <!-- Footer -->
  <div class="footer fixed bottom-0 left-0 right-0 z-20">
    <slot name="footer" />
  </div>

  <!-- Decorative images -->
  <img
    v-if="showDecorations"
    class="playnlearn fixed bottom-8 left-4 z-10 pointer-events-none opacity-80"
    src="../media/home/play_and_learn3.png"
    alt=""
  />
  <img
    v-if="showDecorations"
    class="animals fixed bottom-4 right-4 z-10 pointer-events-none opacity-80"
    src="../media/home/rocket.png"
    alt=""
  />

  <!-- Leaf decorations — rendered once, not copy-pasted 3x -->
  <section v-if="showDecorations" class="pointer-events-none" aria-hidden="true">
    <LeafDecoration v-for="n in 3" :key="n" :extra-class="n > 1 ? `leaf${n - 1}` : ''" />
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import LeafDecoration from './LeafDecoration.vue';
import { loaderGIF } from '../scripts/img_sound_imports.js';
import { homePageImages } from '../scripts/img_sound_imports.js';
import { createIcons, icons } from 'lucide';
const props = defineProps({
  /** Show the codely logo in the header */
  showHeaderLogo: { type: Boolean, default: true },
  /** Show leaf/rocket/playnlearn decorations */
  showDecorations: { type: Boolean, default: true },
  /** Set body background image (pass false to skip) */
  useBgImage: { type: Boolean, default: true },
});

const loading = ref(true);

onMounted(() => {
  if (props.useBgImage) {
    document.body.style.backgroundImage = `url(${homePageImages.bg})`;
    document.body.style.backgroundPosition = 'center';
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundRepeat = 'no-repeat';
  }

  // Mirror the original onload="hidePreloader()" behaviour
  // hidePreloader is called from boot.js and reveals elements — keep that call,
  // but also flip our local loading flag so the Vue preloader div disappears.
  loading.value = false;
  createIcons({
    icons,
    attrs: {
      width: 16,
      height: 16,
    },
  });
});
</script>
